import { useEffect } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';

import Outlet from '@shared/uikit/outlet';
import { useGuardUser } from '@app/queries/user/useGuardUser';
import { useDispatch } from 'react-redux';
import {
  logout,
  setLastUploadedReportAt,
  setPermissions,
  setUser,
} from '@app/redux/features/userSlice';
import { useReportLastSyncDate } from '@app/queries/main/useReportLastSyncDate';
import { usePermissionList } from '@app/queries/user/usePermission';

const PrivateLayout = () => {
  const location = useLocation();
  const guardUserFetcher = useGuardUser();
  const permissionListFetcher = usePermissionList();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const reportLastSyncDateFetcher = useReportLastSyncDate();

  useEffect(() => {
    (async () => {
      const user = await guardUserFetcher.fetch();
      dispatch(setUser(user));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const permissions = await permissionListFetcher.fetch();
      dispatch(setPermissions(permissions));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const reportLastSyncDate = await reportLastSyncDateFetcher.fetch();
      dispatch(setLastUploadedReportAt(reportLastSyncDate));
    })();
  }, []);

  useEffect(() => {
    if (guardUserFetcher.isError) {
      dispatch(logout());
      navigate('/login');
    }
  }, [guardUserFetcher.isError]);

  const loading = guardUserFetcher.isPending || !guardUserFetcher.isSuccess;

  if (loading) {
    //return location.pathname.includes('settings') ? <Outlet /> : <Loading />;
  }

  const goToLogin = () => {
    const loginUrl = `/login?returnURL=${location.pathname}${location.search}`;

    return <Navigate to={loginUrl} state={{ from: location }} />;
  };

  return localStorage.getItem('tokens') ? <Outlet /> : goToLogin();
};

export default PrivateLayout;
